import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Card, Table, Typography, Button, InputNumber, Popconfirm, Space, Select, Modal, DatePicker, AutoComplete, Tooltip, Dropdown, Menu } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, InfoCircleOutlined, PlusOutlined, RedoOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../Services/Manage/LetterService";
import Title from "antd/es/skeleton/Title";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { UserService } from "../../../Services/Manage/UserService";
import { BankService } from "../../../Services/Manage/BankService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CreatePayment from "../../modals/CreatePayment";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";

const AddQuotationData = ({
    followDate,
    Eqslected,
    data,
    selectedDate,
    eqData,
    customerForm
}) => {
    const { Text, Title } = Typography;
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(3);
    const [grandTotal, setGrandTotal] = useState(0);
    const [message, msgContc] = useMessage();
    const [letterHead, setLetterHead] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedTC, setSelectedTC] = useState([]);
    const [selectedTCOption, setSelectedTCOption] = useState([]);
    const [dgSign, setDGsign] = useState(null);
    const [dgSignOption, setDGsignOption] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [bankAc, setBankAc] = useState(null);
    const [bankAcOption, setBankAcOption] = useState([]);
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);

    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [quotationNo, setQuotationNo] = useState(null);
    const [quoteTwo, setQuoteTwo] = useState(false);
    const [taxRate, setTaxRate] = useState(0);
    const [autoSuggestion, setSuggestion] = useState({
        products: {},
        services: [],
    });

    const handlePreview = () => {
        if (selectedValue) {
            setIsModalOpen(true);
        }
    };

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            setLetterHead(
                request.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);

        }
    };
    const getAllProductSuggestions = async () => {
        try {
            const res = await EnquiryService.getAllGenSuggestions();
            setSuggestion(buildSelectOptions(res));

        } catch (error) {
            console.error(error);
        }
    };


    const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
    const handleSearch = (value) => {
        setOptions(
            value
                ? taxOptions
                    .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
                    .map((tax) => ({ value: tax }))
                : []
        );
    };

    const getBankAcOption = async () => {
        try {
            const request = await BankService.getAllBank();
            setBankAcOption(
                request.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);

        }
    };

    const getAllTCData = async () => {
        try {
            const response = await LetterService.getAllTC();
            setSelectedTCOption(
                response.data.map((item, index) => ({
                    label: item.tag,
                    value: item.id,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);
        }
    };

    const getDigitalSign = async () => {
        try {
            const response = await QuotationService.getDigitalSign();
            setDGsignOption(
                response.data.map((item) => ({
                    label: (
                        <img
                            src={`${ENDPOINT.base}/${item.image_path}`}
                            alt={`Signature ${item.id}`}
                            style={{ width: "100px", height: "auto", objectFit: "contain" }}
                        />
                    ),
                    value: item.id,
                    title: `Signature ${item.id}`,
                    ...item,
                }))
            );
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllLetterhead();
        getAllTCData();
        getBankAcOption();
        getDigitalSign();
        getAllProductSuggestions();
        form.setFieldsValue({
            quotationNo: data,
        });
    }, [data, form]);

    const numberToWords = (num) => {
        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];

        if (num === 0) return "Zero";

        let str = "";
        let grp = 0;

        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let chunkStr = "";
                if (chunk > 99) {
                    chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
                    chunk %= 100;
                }
                if (chunk > 19) {
                    chunkStr += b[Math.floor(chunk / 10)] + " ";
                    chunk %= 10;
                }
                if (chunk > 0) chunkStr += a[chunk] + " ";
                str = chunkStr + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000);
            grp++;
        }
        return str.trim();
    };

    useEffect(() => {
        calculateGrandTotal();

    }, [dataSource, taxRate, quoteTwo]);

    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const handleChange = (key, field, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === key) {
                const updatedItem = { ...item, [field]: value };

                if (quoteTwo) {
                    // Quote 2 calculations
                    const qty = updatedItem.qty || 0;
                    updatedItem.supply_amt = Math.round(qty * (updatedItem.supply_rate || 0));
                    updatedItem.install_amt = Math.round(qty * (updatedItem.install_rate || 0));
                } else {
                    // Regular calculation
                    const basePrice = updatedItem.qty * updatedItem.unitprice;
                    const taxPercent = updatedItem.tax || 0;
                    const total = basePrice + (basePrice * taxPercent) / 100;
                    updatedItem.totalprice = Math.round(total);
                }

                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };

    const handleDescriptionSelect = (rowKey, value, option) => {
        if (!option) {
            setDataSource(prev =>
                prev.map(item =>
                    item.key === rowKey
                        ? {
                            ...item,
                            description: "",
                            descriptionMeta: null,
                            unit: "",
                            sku: "",
                            tax: 0,
                            unitprice: 0,
                            totalprice: 0,
                            supply_rate: 0,
                            supply_amt: 0,
                            install_rate: 0,
                            install_amt: 0,
                        }
                        : item
                )
            );
            return;
        }

        const id = option.props["data-id"];
        const type = option.props["data-type"];
        const name = option.props["data-name"];

        setDataSource(prev =>
            prev.map(item => {
                if (item.key !== rowKey) return item;

                let unitprice = 0;
                let unit = "";
                let sku = "";
                let tax = 0;
                let desc_id ="";
                let meta = null;

                /* ===== PRODUCT ===== */
                if (type === "product") {
                    const product = Object.values(autoSuggestion.products || {})
                        .flat()
                        .find(p => String(p.id) === String(id));

                    if (product) {
                        unitprice = Number(product.unit_price || 0);
                        unit = product.unit || "";
                        sku = product.sku || "";
                        tax = Number(product.gst || 0);
                        desc_id = product.id || "";


                        meta = {
                            type: "product",
                            name: product.name,
                            sku: product.sku,
                            category: product.category,
                            unit: product.unit,
                            unit_price: product.unit_price,
                        };
                    }
                }

                /* ===== SERVICE / GENERATOR ===== */
                if (type === "service") {
                    const service = autoSuggestion.services.find(
                        s => String(s.id) === String(id)
                    );

                    if (service) {
                        unitprice = Number(service.price || 0);
                        unit = service.unit || "";
                        sku = service.sku || "";
                        tax = Number(service.gst || 0);
                        desc_id = service.id;


                        meta = {
                            type: "service",
                            name: service.name,
                            sku: service.sku,
                        };
                    }
                }

                if (type === "generator") {
                    const generator = autoSuggestion.services.find(s => s.id === id);
                    if (generator) {
                        unitprice = Number(generator.price || 0);
                        unit = generator.unit || "";
                        sku = generator.sku || "";
                        desc_id = generator.id;
                        tax = Number(generator.gst || item.tax || 0);
                    }   
                }

                const qty = item.qty || 1;
                const base = qty * unitprice;
                const totalprice = Math.round(base + (base * tax) / 100);

                return {
                    ...item,
                    description: name,
                    unit,
                    sku,
                    tax,
                    type,
                    desc_id,
                    unitprice,
                    totalprice,
                    descriptionMeta: meta,
                    supply_rate: item.supply_rate || 0,
                    supply_amt: item.supply_amt || 0,
                    install_rate: item.install_rate || 0,
                    install_amt: item.install_amt || 0,
                };
            })
        );
    };


    const calculateGrandTotal = () => {
        if (quoteTwo) {
            // Quote 2 calculation
            const supplyTotal = dataSource.reduce((sum, item) => sum + (item.supply_amt || 0), 0);
            const installTotal = dataSource.reduce((sum, item) => sum + (item.install_amt || 0), 0);

            const supplyTax = Math.round((supplyTotal * taxRate) / 100);
            const installTax = Math.round((installTotal * taxRate) / 100);

            const total = supplyTotal + installTotal + supplyTax + installTax;
            setGrandTotal(total);
        } else {
            // Regular calculation
            const total = dataSource.reduce((sum, item) => sum + item.totalprice, 0);
            setGrandTotal(total);
        }
    };

    const buildSelectOptions = (apiData) => {
        const options = [];

        console.log(":apiData:", apiData);

        /* ================= PRODUCTS ================= */
        if (apiData.products) {
            const productGroups = Object.entries(apiData.products).map(
                ([subGroupName, items]) => ({
                    label: subGroupName, // PIPES & INSULATION
                    options: items.map((item) => ({
                        label: `${item.name} (${item.sku})`,
                        value: `product-${item.id}`,
                        searchLabel: `${item.name} ${item.sku} ${subGroupName}`,
                        meta: {
                            id: item.id,
                            type: "product",
                        },
                    })),
                })
            );

            options.push({
                label: "PRODUCTS",
                options: productGroups,
            });
        }

        /* ================= SERVICES ================= */
        if (apiData.services) {
            options.push({
                label: "GENERATOR",
                options: apiData.generator.map((item) => ({
                    label: `${item.name} (${item.sku})`,
                    value: `generator-${item.id}`,
                    searchLabel: `${item.name} ${item.sku}`,
                    meta: {
                        id: item.id,
                        type: "generator",
                    },
                })),
            });
        }

        // return options;
        return {
            products: apiData.products || {},
            services: apiData.generator || [],
        };
    };

    const handleAddPayment = async () => {
        try {
            const request = form.getFieldsValue();
            console.log("handleAddPayment", request.quotationNo);

            // save quotationNo and open modal
            setQuotationNo(request.quotationNo);
            setPaymentModalOpen(true);
        } catch (error) {
            console.error("Error in handleAddPayment:", error);
        }
    };

    const handleDecsChange = (rowKey, field, value) => {
        setDataSource((prev) =>
            prev.map((item) =>
                item.key === rowKey ? { ...item, [field]: value } : item
            )
        );

        console.log("Selected type:", value);
    };

    const handleDescriptionChange = async (rowKey, text) => {
        setDataSource((prev) =>
            prev.map((item) =>
                item.key === rowKey ? { ...item, description: text } : item
            )
        );

        if (!text) return;

        // const res = await EnquiryService.getAllProductSuggestions(text);

        // const groupedOptions = buildAutoOptions(res);
        // setSuggestion(groupedOptions);
    };

    const renderDescriptionTooltip = (record) => {
        if (!record?.descriptionMeta) {
            return "Select a product or service";
        }

        const d = record.descriptionMeta;

        if (d.type === "service") {
            return (
                <div>
                    <div><strong>Power Machine:</strong> {d.name}</div>
                    <div><strong>Code:</strong> {d.sku}</div>
                </div>
            );
        }

        if (d.type === "product") {
            return (
                <div>
                    <div><strong>Product:</strong> {d.name}</div>
                    <div><strong>HSN/SAC:</strong> {d.sku}</div>
                    <div><strong>Category:</strong> {d.category}</div>
                    <div><strong>Unit:</strong> {d.unit}</div>
                    <div><strong>Unit Price:</strong> {d.unit_price}</div>
                </div>
            );
        }

        return "Select a product or service";
    };

    const InfoIcon = ({ title }) => (
        <Tooltip placement="topRight" title={title}>
            <ExclamationCircleOutlined
                style={{ color: "#999", cursor: "pointer" }}
                onClick={(e) => e.stopPropagation()}
            />
        </Tooltip>
    );

    // Regular columns
    const regularColumns = [
        {
            title: "SI No",
            dataIndex: "key",
            width: '5%',
            align: 'center',
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span>Description</span>
                    <RedoOutlined onClick={() => getAllProductSuggestions()} style={{ cursor: "pointer" }} />
                </div>
            ),
            width: '32%',
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <Select
                    showSearch
                    allowClear

                    style={{ width: 500 }}
                    placeholder="Select product / service"
                    optionFilterProp="data-search"
                    optionLabelProp="label"
                    size="large"
                    value={record.description}
                    prefix={
                        <Tooltip
                            placement="right"
                            title={renderDescriptionTooltip(record)}
                        >
                            <ExclamationCircleOutlined
                                style={{
                                    color: record.description ? "#1677ff" : "#999",
                                    cursor: record.description ? "pointer" : "not-allowed",
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </Tooltip>
                    }

                    onChange={(value, option) =>
                        handleDescriptionSelect(record.key, value, option)
                    }
                >
                    {/* ================= SERVICES ================= */}
                    {autoSuggestion.services?.length > 0 && (
                        <>
                            {/* Services header (ONLY ONCE) */}
                            <Select.Option
                                disabled
                                key="services-header"
                                style={{
                                    fontWeight: 600,
                                    cursor: "default",
                                    background: "#fafafa",
                                }}
                            >
                                POWER MACHINES
                            </Select.Option>

                            {/* Service options */}
                            {autoSuggestion.services.map((item) => (
                                <Select.Option
                                    key={`service-${item.id}`}
                                    value={`service-${item.id}`}
                                    data-id={item.id}
                                    data-name={item.name}
                                    data-type="service"
                                    data-search={`${item.name} ${item.sku}`}


                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 8,
                                        }}
                                    >
                                        <span>
                                            {item.name} ({item.sku})
                                        </span>

                                        <Tooltip
                                            placement="right"
                                            title={
                                                <div>
                                                    <div><strong>Power machine Name:</strong> {item.name}</div>
                                                    <div><strong>Code:</strong> {item.sku}</div>
                                                </div>
                                            }
                                        >
                                            <ExclamationCircleOutlined
                                                style={{ color: "#999", cursor: "pointer" }}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </Tooltip>
                                    </div>
                                </Select.Option>
                            ))}
                        </>
                    )}

                    {/* ================= PRODUCTS ================= */}
                    {autoSuggestion.products &&
                        Object.entries(autoSuggestion.products).map(
                            ([categoryName, items]) => (
                                <React.Fragment key={categoryName}>
                                    {/* Category header */}
                                    <Select.Option
                                        disabled
                                        key={`cat-${categoryName}`}
                                        style={{
                                            fontWeight: 400,
                                            cursor: "default",
                                            background: "#fafafa",
                                        }}
                                    >
                                        {categoryName}
                                    </Select.Option>

                                    {/* Product options */}
                                    {items.map((item) => (
                                        <Select.Option
                                            key={`product-${item.id}`}
                                            value={`product-${item.id}`}
                                            data-id={item.id}
                                            data-name={item.name}
                                            data-type="product"
                                            data-search={`${item.name} ${item.sku} ${categoryName}`}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    gap: 8,
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        maxWidth: 400,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    {item.name} ({item.sku})
                                                </span>

                                                <Tooltip
                                                    placement="right"
                                                    title={
                                                        <div>
                                                            <div><strong>Product Name:</strong> {item.name}</div>
                                                            <div><strong>HSN/SAC Code:</strong> {item.sku}</div>
                                                            <div><strong>Category:</strong> {categoryName}</div>
                                                            <div><strong>Unit:</strong> {item.unit}</div>
                                                            <div><strong>Unit Price:</strong> {item.unit_price}</div>
                                                        </div>
                                                    }
                                                >
                                                    <ExclamationCircleOutlined
                                                        style={{ color: "#999", cursor: "pointer" }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </Select.Option>
                                    ))}
                                </React.Fragment>
                            )
                        )}


                </Select>
            ),
        },

        {
            title: "Qty",
            dataIndex: "qty",
            align: 'center',
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "qty", value)}
                />
            ),
        },
        {
            title: "HSN/SAC Code",
            dataIndex: "sku",
            width: '10%',
            align: 'center',
            key: "sku",
            render: (text, record) => (
                <Input
                    value={text}
                    onChange={(e) => handleChange(record.key, "sku", e.target.value)}
                />
            ),
        },
        {
            title: "Unit",
            dataIndex: "unit",
            align: 'center',
            key: "unit",
            render: (text, record) => (
                <Input
                    readOnly
                    value={text}
                    onChange={(value) => handleChange(record.key, "unit", value)}
                />
            ),
        },
        {
            title: "Unit Price",
            dataIndex: "unitprice",
            align: 'center',
            width: '12%',
            key: "unitprice",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "unitprice", value)}
                />
            ),
        },
        {
            title: "Tax (in %)",
            dataIndex: "tax",
            width: '9%',
            align: 'center',
            key: "tax",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "tax", value)}
                />
            ),
        },
        {
            title: "Total Price",
            dataIndex: "totalprice",
            align: 'center',
            key: "totalprice",
            render: (text) => <Text>{text}</Text>,
            width: '9%'
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            width: 120,
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<PlusOutlined />}
                        type="dashed"
                        size="large"
                        style={{ marginRight: 8 }}
                        onClick={() => handleAdd(record.key)}
                    />
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <Button
                            icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // Quote 2 columns
    const quote2Columns = [
        {
            title: "SI No",
            dataIndex: "key",
            width: "5%",
            align: "center",
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span>Description</span>
                    <RedoOutlined onClick={() => getAllProductSuggestions()} style={{ cursor: "pointer" }} />
                </div>
            ),
            width: '25%',
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <Select
                    showSearch
                    allowClear
                    style={{ width: 400 }}
                    placeholder="Select product / service"
                    optionFilterProp="data-search"
                    optionLabelProp="label"
                    size="large"
                    value={record.description}
                    suffixIcon={
                        <InfoIcon
                            title={
                                record.description
                                    ? renderDescriptionTooltip(record)
                                    : "Select a product or service"
                            }
                        />
                    }
                    onChange={(value, option) =>
                        handleDescriptionSelect(record.key, value, option)
                    }
                >
                    {/* ================= SERVICES / POWER MACHINES ================= */}
                    {autoSuggestion.services?.length > 0 && (
                        <>
                            <Select.Option
                                disabled
                                key="services-header"
                                style={{
                                    fontWeight: 600,
                                    cursor: "default",
                                    background: "#fafafa",
                                }}
                            >
                                POWER MACHINES
                            </Select.Option>
                            {autoSuggestion.services.map((item) => (
                                <Select.Option
                                    key={`service-${item.id}`}
                                    value={`service-${item.id}`}
                                    data-id={item.id}
                                    data-name={item.name}
                                    // data-type="service"
                                    data-type="generator"
                                    data-search={`${item.name} ${item.sku}`}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 8,
                                        }}
                                    >
                                        <span>
                                            {item.name} ({item.sku})
                                        </span>
                                        <Tooltip
                                            placement="right"
                                            title={
                                                <div>
                                                    <div><strong>Power Machine:</strong> {item.name}</div>
                                                    <div><strong>Code:</strong> {item.sku}</div>
                                                </div>
                                            }
                                        >
                                            <ExclamationCircleOutlined
                                                style={{ color: "#999", cursor: "pointer" }}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </Tooltip>
                                    </div>
                                </Select.Option>
                            ))}
                        </>
                    )}

                    {/* ================= PRODUCTS ================= */}
                    {autoSuggestion.products &&
                        Object.entries(autoSuggestion.products).map(
                            ([categoryName, items]) => (
                                <React.Fragment key={categoryName}>
                                    <Select.Option
                                        disabled
                                        key={`cat-${categoryName}`}
                                        style={{
                                            fontWeight: 400,
                                            cursor: "default",
                                            background: "#fafafa",
                                        }}
                                    >
                                        {categoryName}
                                    </Select.Option>
                                    {items.map((item) => (
                                        <Select.Option
                                            key={`product-${item.id}`}
                                            value={`product-${item.id}`}
                                            data-id={item.id}
                                            data-name={item.name}
                                            data-type="product"
                                            data-search={`${item.name} ${item.sku} ${categoryName}`}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    gap: 8,
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        maxWidth: 300,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    {item.name} ({item.sku})
                                                </span>
                                                <Tooltip
                                                    placement="right"
                                                    title={
                                                        <div>
                                                            <div><strong>Product Name:</strong> {item.name}</div>
                                                            <div><strong>HSN/SAC Code:</strong> {item.sku}</div>
                                                            <div><strong>Category:</strong> {categoryName}</div>
                                                            <div><strong>Unit:</strong> {item.unit}</div>
                                                            <div><strong>Unit Price:</strong> {item.unit_price}</div>
                                                        </div>
                                                    }
                                                >
                                                    <ExclamationCircleOutlined
                                                        style={{ color: "#999", cursor: "pointer" }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </Select.Option>
                                    ))}
                                </React.Fragment>
                            )
                        )}
                </Select>
            ),
        },
        {
            title: "Qty",
            dataIndex: "qty",
            width: "5%",
            align: "center",
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.key, "qty", value)}
                />
            ),
        },
        {
            title: "HSN/SAC Code",
            dataIndex: "sku",
            width: "10%",
            align: "center",
            key: "sku",
            render: (text, record) => (
                <Input
                    value={text}
                    onChange={(e) => handleChange(record.key, "sku", e.target.value)}
                />
            ),
        },
        {
            title: "Unit",
            dataIndex: "unit",
            width: '7%',
            align: 'center',
            key: "unit",
            render: (text, record) => (
                <Input
                    readOnly
                    value={text}
                    onChange={(value) => handleChange(record.key, "unit", value)}
                />
            ),
        },
        {
            title: "SUPPLY & INSTALLATION",
            align: "center",
            children: [
                {
                    title: "RATE",
                    dataIndex: "supply_rate",
                    key: "supply_rate",
                    // width: "8%",
                    align: "center",
                    render: (text, record) => (
                        <InputNumber
                            min={0}
                            value={text}
                            onChange={(value) => handleChange(record.key, "supply_rate", value)}
                        />
                    ),
                },
                {
                    title: "AMOUNT",
                    dataIndex: "supply_amt",
                    key: "supply_amt",
                    // width: "8%",
                    align: "center",
                    render: (text) => <Text>{text}</Text>,
                },
            ],
        },
        // {
        //     title: "INSTALLATION",
        //     align: "center",
        //     children: [
        //         {
        //             title: "RATE",
        //             dataIndex: "install_rate",
        //             key: "install_rate",
        //             width: "8%",
        //             align: "center",
        //             render: (text, record) => (
        //                 <InputNumber
        //                     min={0}
        //                     value={text}
        //                     onChange={(value) => handleChange(record.key, "install_rate", value)}
        //                 />
        //             ),
        //         },
        //         {
        //             title: "AMOUNT",
        //             dataIndex: "install_amt",
        //             key: "install_amt",
        //             width: "8%",
        //             align: "center",
        //             render: (text) => <Text>{text}</Text>,
        //         },
        //     ],
        // },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 120,
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<PlusOutlined />}
                        type="dashed"
                        size="large"
                        style={{ marginRight: 8 }}
                        onClick={() => handleAdd(record.key)}
                    />
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                    >
                        <Button icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const columns = quoteTwo ? quote2Columns : regularColumns;

    const handleNewAdd = () => {
        setDataSource([...dataSource,
        {
            key: count,
            description: "",
            qty: 1,
            unitprice: 0,
            totalprice: 0,
            supply_rate: 0,
            supply_amt: 0,
            install_rate: 0,
            install_amt: 0,
        },]);
        setCount(count + 1);
    };

    const handleQuoteTwo = () => {
        setQuoteTwo(!quoteTwo);
        console.log("quoteTwo", !quoteTwo);
    };

    const handleAdd = (key) => {
        const newRow = {
            key: count,
            description: "",
            qty: 1,
            unitprice: 0,
            totalprice: 0,
            supply_rate: 0,
            supply_amt: 0,
            install_rate: 0,
            install_amt: 0,
        };
        const index = dataSource.findIndex((item) => item.key === key);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);
        setDataSource(newData);
        setCount(count + 1);
    };

    const menu = {
        items: [
            {
                key: "draft",
                label: "Save as Draft",
                onClick: () => handleSave("Draft"),
            },
        ],
    };

    const handleSave = async (status = "Active") => {
        try {
            console.log("Saved Data:", dataSource);

            if (!dataSource || dataSource.length <= 0) {
                return message.warning("Please Add contents");
            }

            const customerValues = customerForm.getFieldsValue();
            await customerForm.validateFields();

            const request = form.getFieldsValue();
            console.log("Request:", request);
            console.log(selectedDate);

            // const formattedData = dataSource.map(({ key, descriptionMeta, ...rest }) => ({
            //     ...rest,
            //     type: item.type,
            //     qu_no: request.quotationNo
            // }));

            const formattedData = dataSource.map((item) => ({
                id: item.id,
                description: item.description,
                qty: item.qty,
                sku: item.sku,
                qu_no: request.quotationNo,
                unit: item.unit,
                desc_id: item.desc_id,
                type: item.type,

                // totalprice: item.totalprice,
                // unitprice: item.unitprice,
                // tax: item.tax,
                ...(!quoteTwo && {
                    totalprice: item.totalprice,
                    unitprice: item.unitprice,
                    tax: item.tax,
                }),
                // Add Quote 2 fields
                supply_rate: item.supply_rate || 0,
                supply_amt: item.supply_amt || 0,
                install_rate: item.install_rate || 0,
                install_amt: item.install_amt || 0,
            }));
            
            console.log("formattedData", formattedData);


            const user = await UserService.getOmeUser();
            const data_insert = {
                qu_no: request.quotationNo,
                eq_no: eqData?.eq_id,
                tax_id: request?.tax_id,
                tax_type: request?.tax_type,
                tc_id: selectedValue?.id || null,
                sign_id: dgSign?.id || null,
                added_by: user.uid,
                bank_id: bankAc?.value || null,

                ...(taxRate && { tax: taxRate }),
                ...(request && { vaild_date: request.vaild_date }),
                ...(request && { supply_add: request.supply_add }),

                ...(selectedDate && { date: selectedDate }),
                ...(followDate && { n_follow_up: followDate }),

                status: status === "Draft" ? "Draft" : "Active",
            };

            const payload = {
                ...customerValues,
                qu_id: request.quotationNo,
                n_follow_up: customerValues.n_follow_up
                    ? customerValues.n_follow_up.format("DD-MM-YYYY")
                    : null,
            };

            const send_both = {
                formattedData: formattedData,
                quotation_insert: data_insert,
                ...(eqData?.eq_id ? {} : { customer_data: payload }),
            };
            console.log("Formatted Data:", send_both);

            const requests = await QuotationService.createQuotation(send_both);
            console.log(requests);

            if (requests.status) {
                message.success(requests.message);
                await navigate("/quotation/edit", { state: { qu_no: requests?.data?.qu_no } });
            } else {
                message.error(requests.message);
            }

        } catch (error) {
            console.error(error);

        }
    };


    const handleClear = async () => {
        setDataSource([]);
    }

    return (
        <>
            {msgContc}
            <Form form={form} layout="vertical">
                <Row gutter={[16, 16]} style={{ width: "100%" }}>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Quotation No"
                            name="quotationNo"
                            initialValue={data}
                        >
                            <Input size="large" readOnly />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} style={{ display: "none" }}>
                        <Form.Item
                            label="Tax type"
                            name="tax_type"
                            initialValue="GST"
                        >
                            <AutoComplete
                                allowClear
                                style={{ width: "100%" }}
                                options={options}
                                disabled
                                onSearch={handleSearch}
                                placeholder="Enter Tax type (e.g. GST, VAT)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="GST No"
                            name="tax_id"
                            initialValue={data?.cus_gst}
                        >
                            <Input
                                allowClear
                                placeholder="Enter ID (e.g. 09AAACH7409R1ZZ)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Vaild Till"
                            name="vaild_date"
                            initialValue={data?.vaild_date}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                size="large"
                                format="DD-MM-YYYY"
                                disabledDate={(current) =>
                                    current && current < dayjs().startOf("day")
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            label="Shipping Address"
                            name="supply_add"
                            initialValue={data?.supply_add}
                        >
                            <Input.TextArea
                                rows={3}
                                allowClear
                                placeholder="Enter Address"
                                size="large"
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>


            <Card
                style={{ marginTop: '30px', borderBlockColor: 'black' }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                            height: "64px",
                        }}
                    >
                        <Button
                            icon={<PlusOutlined />}
                            size="large"
                            type="primary"
                            onClick={handleNewAdd}
                        >
                            Add Row
                        </Button>

                        <Button
                            icon={<PlusOutlined />}
                            size="large"
                            color="primary"
                            variant="filled"
                            onClick={handleQuoteTwo}
                        >
                            {quoteTwo ? 'Regular View' : 'Quote 2'}
                        </Button>
                    </div>

                    <Table
                        dataSource={dataSource}
                        size="small"
                        columns={columns}
                        pagination={false}
                        rowKey="key"
                        summary={() => {
                            if (quoteTwo) {
                                // Quote 2 Summary
                                const totalQty = dataSource.reduce((sum, item) => sum + (item.qty || 0), 0);
                                const supplyTotal = dataSource.reduce((sum, item) => sum + (item.supply_amt || 0), 0);
                                const installTotal = dataSource.reduce((sum, item) => sum + (item.install_amt || 0), 0);

                                const supplyTax = Math.round((supplyTotal * taxRate) / 100);
                                const installTax = Math.round((installTotal * taxRate) / 100);

                                const supplyWithTax = supplyTotal + supplyTax;
                                const installWithTax = installTotal + installTax;

                                return (
                                    <>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={2}>
                                                <Text strong>Subtotal</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2}>
                                                <Text strong>Qty: {totalQty}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={5}>
                                                <Text strong>{supplyTotal}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={6}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={7}>
                                                <Text strong>{installTotal}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={8}></Table.Summary.Cell>
                                        </Table.Summary.Row>

                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={2}>
                                                <Text strong>Tax Rate (%)</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} colSpan={3}>
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    value={taxRate}
                                                    onChange={(value) => setTaxRate(value || 0)}
                                                    placeholder="Enter tax %"
                                                    style={{ width: '100%' }}
                                                />
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={5}>
                                                <Text>{supplyTax}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={6}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={7}>
                                                <Text>{installTax}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={8}></Table.Summary.Cell>
                                        </Table.Summary.Row>

                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={2}>
                                                <Text strong>Total with Tax</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} colSpan={3}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={5}>
                                                <Text strong>{supplyWithTax}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={6}></Table.Summary.Cell>
                                            <Table.Summary.Cell index={7}>
                                                <Text strong>{installWithTax}</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={8}></Table.Summary.Cell>
                                        </Table.Summary.Row>

                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={5}>
                                                <Text strong style={{ fontSize: '16px' }}>Grand Total</Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={5} colSpan={4}>
                                                <Text strong style={{ fontSize: '16px' }}>{grandTotal}</Text>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </>
                                );
                            } else {
                                // Regular Summary
                                let totalQty = 0;
                                let totalprice = 0;

                                dataSource.forEach(({ qty, totalprice: rowTotal }) => {
                                    totalQty += qty;
                                    totalprice += rowTotal;
                                });

                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} colSpan={2}>
                                            <Text strong>Total</Text>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2}>
                                            <Text strong>{totalQty}</Text>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={5}></Table.Summary.Cell>
                                        <Table.Summary.Cell index={6}>
                                            <Text strong>{totalprice}</Text>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7}></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }
                        }}
                        scroll={{ x: 'max-content' }}
                    />

                    <Row style={{ marginTop: 16 }}>
                        <Col span={12}>
                            <Text italic>In Words: {numberToWords(grandTotal)}</Text>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <Text strong>Grand Total: {grandTotal}</Text>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: 16 }}>
                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item label="Select Terms & Condition" style={{ width: "100%" }}>
                                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                        <Select
                                            placeholder="Select option"
                                            options={selectedTCOption}
                                            size="large"
                                            style={{ width: "100%" }}
                                            onChange={(value, option) => setSelectedValue(option)}
                                        />

                                        <Button type="link" onClick={handlePreview}>
                                            Preview
                                        </Button>
                                    </div>

                                    <Modal
                                        title="Preview of selected T&C"
                                        open={isModalOpen}
                                        footer={null}
                                        onCancel={() => setIsModalOpen(false)}
                                    >
                                        {selectedValue?.data ? (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    border: "1px solid #f0f0f0",
                                                    borderRadius: "8px",
                                                    background: "#fafafa",
                                                    minHeight: "100px",
                                                }}
                                                dangerouslySetInnerHTML={{ __html: selectedValue.data }}
                                            />
                                        ) : (
                                            <p>No data selected</p>
                                        )}
                                    </Modal>

                                </Form.Item>
                            </Form>
                        </Col>

                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item
                                    label="Select Bank Account"
                                    name="bank_ac"

                                >
                                    <Select
                                        placeholder="Select option"
                                        options={bankAcOption}

                                        size="large"
                                        style={{ width: "70%" }}
                                        onChange={(value, option) => setBankAc(option)}
                                    />
                                </Form.Item>
                            </Form>
                        </Col>

                        <Col span={12}>
                            <Form layout="vertical">
                                <Form.Item
                                    label="Select Digital signature"
                                    name="dgselect"

                                >
                                    <Select
                                        allowClear
                                        placeholder="Select option"
                                        options={dgSignOption}
                                        size="large"
                                        style={{ width: "50%" }}
                                        optionRender={(option) => option.data.label}
                                        fieldNames={{ label: "title", value: "value" }}
                                        onChange={(value, option) => {
                                            setDGsign(option);
                                        }}
                                    />

                                </Form.Item>
                            </Form>
                        </Col>

                    </Row>

                    <Row justify="end" style={{ marginTop: 16 }}>
                        <Space>
                            <Dropdown.Button
                                size="large"
                                type="primary"
                                onClick={() => handleSave("Active")}
                                menu={menu}
                            >
                                Save
                            </Dropdown.Button>


                            <Popconfirm title="Sure to clear?" onConfirm={handleClear}>
                                <Button danger size="large">
                                    Clear
                                </Button>
                            </Popconfirm>
                        </Space>
                    </Row>
                </div>

                <Modal
                    width={800}
                    title={
                        <Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>
                    }
                    open={paymentModalOpen}
                    onCancel={() => setPaymentModalOpen(false)}
                    footer={null}
                    destroyOnClose
                >
                    {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
                </Modal>
            </Card>
        </>
    );
};

export default AddQuotationData;